var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolvingQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M374.933,166.933H127.467c-4.418,0-8,3.581-8,8v162.133c0,4.419,3.582,8,8,8h247.467 c4.418,0,8-3.581,8-8V174.933C382.933,170.514,379.351,166.933,374.933,166.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M374.933,329.067H127.467c-4.418,0-8,3.581-8,8V499.2c0,4.419,3.582,8,8,8h247.467 c4.418,0,8-3.581,8-8V337.067C382.933,332.647,379.351,329.067,374.933,329.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M374.933,4.8H127.467c-4.418,0-8,3.581-8,8v162.133c0,4.419,3.582,8,8,8h247.467 c4.418,0,8-3.581,8-8V12.8C382.933,8.381,379.351,4.8,374.933,4.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M504,4.8H374.933v502.4H504c4.418,0,8-3.581,8-8V12.8C512,8.381,508.418,4.8,504,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M349.333,30.4H153.067c-4.418,0-8,3.581-8,8v110.933c0,4.419,3.582,8,8,8h196.267 c4.418,0,8-3.581,8-8V38.4C357.333,33.981,353.751,30.4,349.333,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B14D"
    },
    d: "M153.067,149.333V38.4c0-4.419,3.582-8,8-8h-8c-4.418,0-8,3.581-8,8v110.933c0,4.419,3.582,8,8,8h8 C156.649,157.333,153.067,153.753,153.067,149.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M349.333,192.533H153.067c-4.418,0-8,3.581-8,8v110.933c0,4.419,3.582,8,8,8h196.267 c4.418,0,8-3.581,8-8V200.533C357.333,196.114,353.751,192.533,349.333,192.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B14D"
    },
    d: "M153.067,311.467V200.533c0-4.419,3.582-8,8-8h-8c-4.418,0-8,3.581-8,8v110.933c0,4.419,3.582,8,8,8 h8C156.649,319.467,153.067,315.886,153.067,311.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEDEF"
    },
    d: "M237.867,285.867c0-4.419-3.582-8-8-8H42.133c-4.418,0-8,3.581-8,8v102.755h203.733V285.867z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M331.733,283.022c0-2.122-0.843-4.156-2.343-5.658l-48.355-48.355c-1.5-1.5-3.535-2.342-5.657-2.342 h-96.711c-4.418,0-8,3.581-8,8v153.955h161.067V283.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M170.667,312.533H76.8c-4.418,0-8,3.581-8,8v68.089h101.867V312.533z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M281.067,320.533c0-4.419-3.582-8-8-8h-102.4v76.089h110.4V320.533z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F6F7"
    },
    d: "M331.105,286.129c1.264-3.001,0.585-6.464-1.715-8.765l-48.355-48.355 c-2.166-2.166-5.363-2.873-8.235-1.892v51.017c0,4.418,3.582,8,8,8h50.3C331.102,286.132,331.103,286.131,331.105,286.129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6F6F7"
    },
    d: "M289.067,328.533c0-4.419-3.582-8-8-8H84.8c-4.418,0-8,3.581-8,8v60.089h212.267V328.533z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "lightgray"
    },
    d: "M349.333,380.267H153.067c-4.418,0-8,3.581-8,8V473.6c0,4.419,3.582,8,8,8h196.267 c4.418,0,8-3.581,8-8v-85.333C357.333,383.847,353.751,380.267,349.333,380.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "darkgray"
    },
    d: "M153.067,380.267c-4.418,0-8,3.581-8,8V473.6c0,4.419,3.582,8,8,8h77.155V380.267H153.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M204.267,354.667H8c-4.418,0-8,3.581-8,8V473.6c0,4.419,3.582,8,8,8h196.267c4.418,0,8-3.581,8-8 V362.667C212.267,358.247,208.685,354.667,204.267,354.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B14D"
    },
    d: "M8,473.6V362.667c0-4.419,3.582-8,8-8H8c-4.418,0-8,3.581-8,8V473.6c0,4.419,3.582,8,8,8h8 C11.582,481.6,8,478.019,8,473.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M136,380.267H76.267c-4.418,0-8,3.581-8,8V422.4c0,4.419,3.582,8,8,8H136c4.418,0,8-3.581,8-8 v-34.133C144,383.847,140.418,380.267,136,380.267z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.933,
    y: 390.933,
    style: {
      fill: "#ECEDEF"
    },
    width: 54.4,
    height: 28.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M281.067,56h-59.733c-4.418,0-8,3.581-8,8v34.133c0,4.419,3.582,8,8,8h59.733c4.418,0,8-3.581,8-8V64 C289.067,59.581,285.485,56,281.067,56z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 66.667,
    style: {
      fill: "#ECEDEF"
    },
    width: 54.4,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M238.4,276.8h-25.6c-4.418,0-8-3.581-8-8c0-4.419,3.582-8,8-8h25.6c4.418,0,8,3.581,8,8 C246.4,273.219,242.818,276.8,238.4,276.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M255.467,302.4H212.8c-4.418,0-8-3.581-8-8c0-4.419,3.582-8,8-8h42.667c4.418,0,8,3.581,8,8 C263.467,298.819,259.885,302.4,255.467,302.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M272.533,131.733h-42.667c-4.418,0-8-3.581-8-8c0-4.419,3.582-8,8-8h42.667c4.418,0,8,3.581,8,8 C280.533,128.153,276.951,131.733,272.533,131.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E959F"
    },
    d: "M136,456H76.267c-4.418,0-8-3.581-8-8c0-4.419,3.582-8,8-8H136c4.418,0,8,3.581,8,8 C144,452.419,140.418,456,136,456z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolvingQuestion);
export default __webpack_public_path__ + "static/media/solving_question.98c55c65dbdd8cb569e1143f9e9eeec6.svg";
export { ForwardRef as ReactComponent };